// API configuration
// const API_BASE_URL = "http://localhost:8080";
const API_BASE_URL = "https://api.kansasroot.com";

export const authService = {
  login: async (email, password) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });
      const data = await response.json();
      if (data.success) {
        authService.persistSession(data);
      }
      return data;
    } catch (error) {
      console.error("Login error:", error);
      return { success: false, message: "Error connecting to server" };
    }
  },

  sendSignupVerificationCode: async (email) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/signup/send-code`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });
      return await response.json();
    } catch (error) {
      console.error("Send verification code error:", error);
      return { success: false, message: "Error connecting to server" };
    }
  },

  verifySignupCode: async (email, code) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/signup/verify-code`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, code }),
      });
      return await response.json();
    } catch (error) {
      console.error("Verify signup code error:", error);
      return { success: false, message: "Error connecting to server" };
    }
  },

  signup: async ({
    email,
    password,
    firstName,
    lastName,
    address,
    companyName,
    verificationToken,
  }) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          password,
          firstName,
          lastName,
          address,
          companyName,
          role: "CLIENT",
          verificationToken,
        }),
      });
      const data = await response.json();
      if (data.success) {
        authService.persistSession(data);
      }
      return data;
    } catch (error) {
      console.error("Signup error:", error);
      return { success: false, message: "Error connecting to server" };
    }
  },

  logout: () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("idToken");
    localStorage.removeItem("tokenType");
  },

  persistSession: (data) => {
    localStorage.setItem("user", JSON.stringify(data));
    localStorage.setItem("token", data.accessToken || "");
    localStorage.setItem("idToken", data.idToken || "");
    localStorage.setItem("tokenType", data.tokenType || "Bearer");
  },

  getAuthHeaders: () => {
    const token = localStorage.getItem("token");
    const tokenType = localStorage.getItem("tokenType") || "Bearer";

    if (!token) {
      return {};
    }

    return {
      Authorization: `${tokenType} ${token}`,
    };
  },

  getUsers: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/users`, {
        headers: {
          ...authService.getAuthHeaders(),
        },
      });
      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          message: data.message || "You are not authorized to view users",
        };
      }

      return { success: true, users: data };
    } catch (error) {
      console.error("Get users error:", error);
      return { success: false, message: "Error loading users from server" };
    }
  },

  getUser: () => {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  },

  isLoggedIn: () => {
    return localStorage.getItem("token") !== null;
  },
};
